// © Microsoft Corporation. All rights reserved.

import { NavItem } from "./NavItem";
import { html } from "@microsoft/fast-element";
import { startTemplate } from "@microsoft/fast-foundation";

export const navItemTemplate = html<NavItem>`
    <a
        class="control"        
        href="${x => x.href}"
        aria-current="${x => (x.active ? "page" : "false")}"
        tabindex="0"
        role=${x => (x.href ? undefined : "link")}
    >
        ${startTemplate}
        <span class="content" part="content">
            <slot></slot>
        </span>
    </a>
`;
